define("shared/helpers/get-in", ["exports", "@ember/component/helper"], function (_exports, _helper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.getIn = getIn;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/helper"eaimeta@70e063a35619d71f
  /**
   * @module Helpers
   */
  /**
   * @class LaterHelpers
   * @extends Helpers
   */
  /**
   * Gets a string or number value from a nested object and/or array
   *
   * @method get-in
   */
  function getIn(_ref) {
    let [obj, ...keys] = _ref;
    try {
      const result = keys.reduce((prev, key) => prev[key], obj);
      if (typeof result === 'string' || typeof result === 'number') {
        return `${result}`;
      }
      return '';
    } catch (_) {
      return '';
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getInHelper = (0, _helper.helper)(getIn);
  var _default = _exports.default = getInHelper;
});